import { AppConfig as AppConfigModel } from '@app/shared/models/app-config.model';
import { HttpService } from '@app/security/shared/http.service';
import { Injectable } from '@angular/core';
import { Logger } from '@app/logger/logger';
import { WINDOW_PROP_LOG_HTTP_REQ_TIMES } from '@app/shared/constants';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

const lgSfx = '\t(app.config)';

const localConfigurationUrl = 'configuration.local.json';
const configurationUrl = 'configuration.json';

@Injectable({
  providedIn: 'root'
})
export class AppConfig {
  private dispatchUri: string;
  private legacyUri: string;
  private serverUri: string;
  private mapApiScriptUri: string;

  constructor(private http: HttpService, private log: Logger) {}

  public load(): Promise<any> {
    return new Promise<void>((resolve) => {
      this.getConfigurations().subscribe((response: AppConfigModel) => {
        this.populateConfigurations(response);
        resolve();
      });
    });
  }

  public getDispatchUri(): string {
    return this.dispatchUri || '';
  }

  public getMapApiScriptUri(): string {
    return this.mapApiScriptUri || '';
  }

  public getLegacyUri(): string {
    return this.legacyUri || '';
  }

  public getServerUri(): string {
    return this.serverUri || '';
  }

  private getConfigurations(): Observable<AppConfigModel> {
    this.log.log(`loading configuration from ${localConfigurationUrl} ${lgSfx}`);
    return this.http.getAny(localConfigurationUrl).pipe(
      map((response) => {
        if (Array.isArray(response) || !response) {
          throw Error('Config not found or valid');
        } else {
          return response;
        }
      }),
      catchError(() => {
        this.log.log(
          `Local Config file not found, now loading configuration from ${configurationUrl} ${lgSfx}`
        );
        return this.http.getAny(configurationUrl);
      })
    );
  }

  public populateConfigurations(response: AppConfigModel): void {
    this.dispatchUri = response.DISPATCH_URI || '';
    this.legacyUri = response.LEGACY_URI || '';
    this.serverUri = response.SERVER_URI || '';
    this.mapApiScriptUri = response.MAP_API_SCRIPT_URI || '';

    if (this.dispatchUri?.endsWith('/')) {
      this.dispatchUri = this.dispatchUri.slice(0, this.dispatchUri.length - 1);
    }
    if (this.legacyUri?.endsWith('/')) {
      this.legacyUri = this.legacyUri.slice(0, this.legacyUri.length - 1);
    }
    if (this.serverUri?.endsWith('/')) {
      this.serverUri = this.serverUri.slice(0, this.serverUri.length - 1);
    }

    window[WINDOW_PROP_LOG_HTTP_REQ_TIMES] = 0;

    this.log.info(`AppConfig configuration loaded with: ${lgSfx}`, this);

    if (!this.serverUri) {
      this.log.error(`Loaded configuration but the SERVER_URI is missing ${lgSfx}`);
    }
  }
}
